import { useSelector } from "react-redux";
import TeamMember from "../../../components/common/businessProfileCard";
import ProfileBusinessInfo from "../../../components/common/profileBusinessInfo";
import ProfileCard from "../../../components/common/profileCard";
import ProfilePaymentMethod from "../../../components/common/profilePaymentMethod";
import ProfileRatingCard from "../../../components/common/profileRatingCard";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const BusinessProfile = () => {
  const teamData = useSelector((state) => state);
  const primaryCard = teamData.discount?.res?.find((obj) => obj?.isDefault);
  const userDetails = useSelector((state) => state?.user?.response);
  const appointments = useSelector((state) => state?.appointment);
  const allRating = useSelector((state) => state?.review.totalReviews);
  if (!userDetails || !teamData.business) {
    return (
      <div className="flex h-screen justify-center items-center">
        <Spin
          indicator={<LoadingOutlined />}
          className="flex justify-center"
          size="large"
        />
      </div>
    );
  }

  return (
    <>
      <div className="sm:flex sm:flex-col space-y-2 m-2 sm:items-center xl:space-y-0 xl:grid xl:justify-between xl:grid-cols-2 xl:pt-4">
        <div className="flex flex-col space-y-2 lg:items-center">
          <ProfileCard
            name={`${userDetails?.firstName} ${userDetails?.lastName}`}
            business={teamData?.business?.business?.businessName}
            imgSrc={userDetails?.profileImage}
          />
          <ProfileRatingCard
            type="emailphone"
            email={userDetails?.email}
            phone={userDetails?.phoneNumber}
          />
          <ProfileBusinessInfo data={teamData?.business?.business} />
        </div>
        <div className="flex flex-col space-y-2">
          <div className="flex flex-col space-y-2 sm:space-y-0 sm:w-full sm:flex-row justify-between">
            <TeamMember type="team" count={teamData?.team?.response?.length} />
            {/* <TeamMember type="appointment" count={appointments?.value} /> */}
          </div>
          <ProfileRatingCard type="reviews" data={allRating} />
          <ProfilePaymentMethod
            primaryLast4={primaryCard?.last4}
            count={teamData.discount.res?.length}
            primaryBrand={primaryCard?.brand}
          />
        </div>
      </div>
    </>
  );
};
export default BusinessProfile;
